import { render } from "./titleline.vue?vue&type=template&id=72c7b586&scoped=true"
import script from "./titleline.vue?vue&type=script&lang=js"
export * from "./titleline.vue?vue&type=script&lang=js"

import "./titleline.vue?vue&type=style&index=0&id=72c7b586&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c7b586"]])

export default __exports__